import React from "react";
import "./backgroundImage.scss";

type BackgroundImageProps = {
    className?: string;
    contain?: boolean;
    mobileContain?: boolean;
    style?: React.CSSProperties;
    src?: string;
}

export default class BackgroundImage extends React.Component<BackgroundImageProps> {
    static defaultProps: Partial<BackgroundImageProps> = {
        className: "",
    }

    private get style(): any {
        const ostyle = this.props.style || {};
        const style = {
            ...ostyle,
            '--bgsize': this.props.contain ? 'contain' : 'cover',
            '--bgsizemobile': this.props.mobileContain ? 'contain' : 'cover',
            '--bgimage': `url(${this.props.src})`
        };
        return style;
    }

    render(): React.ReactNode {
        if (!this.props.src) return null;
        return <div style={this.style} className={`component-bgimage ${this.props.className}`} />;
    }
}